import React from "react";
import styled from "styled-components";

const DigitalSkillsBanner = ({ imageSrc, onClose, onClick }) => {
  return (
    <Overlay>
      <ModalBody>
        <CloseIconContainer onClick={onClose}>✖</CloseIconContainer>
        <ModalImage
          src={imageSrc}
          alt="Digital Skills Training"
          onClick={onClick}
        />
      </ModalBody>
    </Overlay>
  );
};

export default DigitalSkillsBanner;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalBody = styled.div`
  position: relative;
  border-radius: 10px;
  display: flex;
  justify-content: center;
`;

const CloseIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  color: white;
`;

const ModalImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: 80% 100%;
  border-radius: 10px;
  cursor: pointer;
`;
